import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import styles from './ProductPricing.module.scss';

const ProductPricing = ({ sponsored, percentOff, salePrice, price }) => (
  <div data-testid="product-pricing-container" className={styles.container}>
    {sponsored && (
      <span
        data-testid="product-pricing-qualified-purchase"
        className={styles.regularPrice}
      >
        $0 - Free with Qualified Purchase
      </span>
    )}
    {!sponsored && (
      <div
        data-testid="product-pricing-not-sponsored"
        className={styles.salePrice}
      >
        {salePrice}
      </div>
    )}
    {!sponsored && percentOff > 0 && (
      <div
        data-testid="product-pricing-not-sponsored-percent-off"
        className={styles.regularPrice}
      >
        MSRP:&nbsp;
        <span
          data-testid="product-pricing-crossed-price"
          className={styles.crossed}
        >
          {price}
        </span>
        <i
          className="fas fa-info-circle"
          data-tip="The price shown represents the product's estimated original retail price."
          data-testid="pricing-tooltip"
        />
        {percentOff && (
          <span className={styles.percentOff}>({percentOff}% off)</span>
        )}
      </div>
    )}
    <ReactTooltip className={styles.tooltip} type="dark" effect="solid" />
  </div>
);

ProductPricing.propTypes = {
  sponsored: PropTypes.bool.isRequired,
  percentOff: PropTypes.number.isRequired,
  salePrice: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

export default ProductPricing;
